import { render, staticRenderFns } from "./IconBookmarkOutline.vue?vue&type=template&id=d5b60784"
import script from "./IconBookmarkOutline.vue?vue&type=script&lang=js"
export * from "./IconBookmarkOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports